import dayjs from "dayjs";

import type { BacklinksTimeSeriesSummary } from "@similarweb/pro-api-client";

import { GRANULARITY_INDEX } from "app/pages/digital-marketing/backlinks/shared/BacklinksConsts";

/**
 * Filters data based on granularity settings
 * @param data Array of arrays of items with Date property
 * @param granularityIndex DAILY, WEEKLY or MONTHLY granularity constant
 * @returns Filtered data based on granularity settings
 */
export const filterDataByGranularity = (
    data: BacklinksTimeSeriesSummary[][],
    granularityIndex: number,
): BacklinksTimeSeriesSummary[][] => {
    const rightNow = dayjs.utc();

    return data.map((dataItems) => {
        return dataItems.filter((item) => {
            if (!item?.Date) {
                return false;
            }

            const currentDateInDayJs = dayjs.utc(item.Date);

            // Invalid date check
            if (!currentDateInDayJs.isValid()) {
                return false;
            }

            const isCurrentDateIdenticalToToday = rightNow.isSame(currentDateInDayJs, "day");
            if (isCurrentDateIdenticalToToday) {
                return true;
            }

            switch (granularityIndex) {
                case GRANULARITY_INDEX.DAILY:
                    return true;
                case GRANULARITY_INDEX.WEEKLY:
                    return currentDateInDayJs.day() === 1; // Monday
                case GRANULARITY_INDEX.MONTHLY:
                    return currentDateInDayJs.date() === 1; // First day of month
                default:
                    return true;
            }
        });
    });
};
